import React from "react";
import "./Footer.css";
import Socials from "../Socials/Socials";
import { menu } from "../../data";

const Footer = () => {
  return (
    <footer className="footer">
      <section className="footer--box-1">
        <ul className="footer--ul-1">
          <li key="logo">
            <ul className="footer--ul-2">
              <li key={"logo"}>
                <img src="/assets/images/logo-white.svg" />
              </li>
              {menu.slice(0, 3).map((link) => (
                <li key={link}>
                  <a href={`#${link}`} className="footer__link body-2">
                    {link}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={`https://d-resume-copy.netlify.app`}
                  className="body-2 footer__link"
                  target="_blank"
                  rel="noreferrer"
                >
                  {menu[3]}
                </a>
              </li>
            </ul>
          </li>
          <li key="social links">
            <Socials />
          </li>
        </ul>
      </section>
    </footer>
  );
};

export default Footer;
